<template>
  <div>
    <button
      class="collapse-button"
      type="button"
      v-bind:class="{ active: isOpen }"
      v-on:click="onClick"
    >
      {{ caption }}
    </button>
    <slot v-if="isOpen" />
  </div>
</template>

<script>
/**
 * @description Название события переключения видимости секции.
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';

export default {
  computed: {
    isOpen() {
      return this.value !== undefined ? this.value : this.drawer;
    },
  },
  data() {
    return {
      drawer: this.initialShow,
    };
  },
  methods: {
    onClick() {
      this.drawer = !this.isOpen;
      this.$emit(NAME_EVENT_INPUT, this.drawer);
    },
  },
  props: {
    caption: { type: String, required: true },
    initialShow: { type: Boolean, default: false },
    value: { default: undefined, type: Boolean },
  },
  name: 'CollapseButton',
};
</script>

<style scoped lang="scss">
.collapse-button {
  display: flex;
  align-items: center;
  color: #0489e0;
  font-weight: 400;
  font-size: 18px;
  line-height: 20px;
  cursor: pointer;
  border-bottom: 1px dotted transparent;
  &:hover {
    border-bottom: 1px dotted #0489e0;
  }
}

.collapse-button:after {
  content: "";
  background-image: url("@/assets/img/checked/checked-blue.svg");
  background-size: contain;
  background-repeat: no-repeat;
  width: 15px;
  height: 8px;
  margin: 0 0 0 10px;
}

.collapse-button.active:after {
  transform: rotate(180deg);
}
</style>
